import { createStore } from 'redux';
import { reactReduxFirebase } from 'react-redux-firebase';
import firebase from 'firebase';

import rootReducer from '../reducers';

const configureStore = (initialState = {}) => {
  const firebaseConfig = {
    apiKey: 'AIzaSyDTrLVNVTpUruAwbL67RrE4X9kZyhhFbsE',
    authDomain: 'jelorr-invite.firebaseapp.com',
    databaseURL: 'https://jelorr-invite.firebaseio.com',
    storageBucket: 'jelorr-invite.appspot.com',
  };

  const rrfConfig = {
    userProfile: 'users',
    presence: 'onlineUsers',
  };

  firebase.initializeApp(firebaseConfig);

  const store = createStore(
    rootReducer,
    {
      ...initialState,
    },
    reactReduxFirebase(firebase, rrfConfig),
  );

  // persistStore(store, { storage: localForage });

  return store;
};

export default configureStore;



// WEBPACK FOOTER //
// ./src/store/configureStore.js